module.exports = __webpack_public_path__ + "static/img/logo_12343.947188a.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/logo_12343.png
// module id = D5o7
// module chunks = 167